export default __webpack_public_path__ + "983a1c97e2c3d89fcc4bbaa8b8e91269.md";